import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--outline);
  @media (max-width: 768px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
  }
`;

const Link = styled(NavLink)`
  padding: 0.4rem 0.75rem;
  border-radius: 8px;
  text-decoration: none;
  font-size: 0.9rem;
  color: var(--onSurfaceVariant);
  white-space: nowrap;
  &.active {
    background: var(--surfaceVariant);
    color: var(--primary);
    font-weight: 600;
  }
`;

export function GrowthNav() {
  return (
    <Nav>
      <Link to="/growth" end>
        Overview
      </Link>
      <Link to="/growth/audits">Audits</Link>
      <Link to="/growth/peers">Peers</Link>
      <Link to="/growth/briefs">Briefs</Link>
      <Link to="/growth/tasks">Tasks</Link>
      <Link to="/growth/settings">Settings</Link>
    </Nav>
  );
}
